import React from 'react';
import '../style.css';
import {Form,Button,Container,Row,Col,Navbar,Nav,NavDropdown,FormControl,label,input,h2,h3,h4,h5} from 'react-bootstrap';

import styled from 'styled-components';
import '../assets/styles/sb-admin-2.css';
import '../assets/styles/sb-admin-2.min.css';
import DataGrid from '../Components/Misc/DataGrid';
import * as XLSX from 'xlsx';


class ExcelUpload extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            excelData:[],
            fileName:'',
            seasonData:[],
            ready: false,
            columnstoview:["YearCode","WeekNo","FromDate","ToDate","Season"]          
                    }
                     }

     handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
          this.setState({file:file.name})
          this.readExcelFile(file);
        }
      };
    
       readExcelFile (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary'});
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(sheet,{raw: false}); // Convert sheet to JSON
          this.setState({excelData:jsonData});
          console.log(jsonData);
        };
        reader.readAsBinaryString(file);
      };

      submitUser=(event)=>{
        event.preventDefault();
        let postData = {
          'userdata':this.state.excelData
        };

        let url = process.env.REACT_APP_DEBUG_URL+'/api/uploaduserdata';
           let token =localStorage.getItem("UserToken");
           const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization': 'Bearer '+token },
            body: JSON.stringify(postData)
           // body: postData
        };

        fetch(url, requestOptions)
        .then(res => res.json())
        .then(result => {

     console.log(result)


        })




      }

      submitData=(event)=>{
        event.preventDefault();
        let postData = {
          'seasondata':this.state.excelData
        };

        let url = process.env.REACT_APP_DEBUG_URL+'/api/updateexceldata';
           let token =localStorage.getItem("UserToken");
           const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Authorization': 'Bearer '+token },
            body: JSON.stringify(postData)
           // body: postData
        };

        fetch(url, requestOptions)
              .then(res => res.json())
              .then(result => {

            console.log('seasondata=',result.seasondata);
            if(result.status=='Success'){
              this.setState({seasonData:result.seasondata,ready:false},()=>{this.setState({ready:true})})
            }
            else{
              alert(result.msg)
            }
            
           this.setState({excelData:[]})


              })
      
      }
    
    
    componentDidMount() { 
      let url = process.env.REACT_APP_DEBUG_URL+'/api/getexceldata';
           let token =localStorage.getItem("UserToken");
           const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','Authorization': 'Bearer '+token }
           
        };
        fetch(url, requestOptions)
        .then(res => res.json())
        .then(result => {
         console.log('seasondata=',result.seasondata);
         this.setState({seasonData:result.seasondata,ready:true})
        })
               
      }


      seteditid=(editid)=>{}
      


      render() { 
        let projectname='TL Image Portal';
        const WorkArea = styled.div`
        background: white;
        left:250;
        height: 100vh;
        display: flex;
        
      `;
if(this.state.ready==false)
                  return(<div></div>)
                  else
      
        return (
            <div id="content-wrapper" className="d-flex flex-column">            
            <div id="content" className='containerh'>              
              <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow" >              
               <div style={{fontSize:'50px',color:'rgb(12 16 167)'}}>{projectname}</div>               
              </nav>             
              <div style={{width:'600px',maxHeight:'500px',overflowY:'scroll',marginBottom:'20px'}}>
              <h2>Upload Excel File</h2>
              <input type="file" accept=".xlsx,.xls" onChange={this.handleFileUpload} />
              <Button variant="primary" type="button" onClick={this.submitData}>
               Submit
              </Button>
               {/* <Button variant="primary" type="button" onClick={this.submitUser}>
               upload user
              </Button>  */}
              <h3>File Name: {this.state.fileName}</h3>
              <table style={{overflow:'scroll'}}>
              <thead>
              <tr>
                {
                  this.state.excelData[0] && Object.keys(this.state.excelData[0]).map((key, index) =>
                     (
                      <th key={index}>{key}</th>
                     ))
                }
            </tr>
            </thead>
           <tbody>
            {
              this.state.excelData.map((row, index) =>
                 (
                   <tr key={index}>
                   {
                    Object.values(row).map((value, idx) =>
                       (
                          <td key={idx}>{value}</td>
                       ))
                   }
                  </tr>
                 ))
           }
        </tbody>
      </table>
      <div>      
      </div>
      </div>
      <h2 style={{textAlign:'center'}}>Week Table</h2>
       <DataGrid  rowsarray={this.state.seasonData}  seteditid={this.seteditid } columns={this.state.columnstoview} showeditbutton={false}/>              
      </div>
      <footer className="sticky-footer bg-white">
        <div className="container my-auto" style={{backgroundColor:'#fff'}}>
          <div className="copyright text-center my-auto">
            <span style={{fontSize:'25px'}}><a href='https://thinkmaster.technology' target='_blank'>Developed & Maintain by Thinkmaster Technology</a></span>
          </div>
        </div>
      </footer>
    </div>
        );
      }




}

export default ExcelUpload;
 